import {UseCase} from '../../base/use-case';
import {UserModel} from '../../models/user/user-model';
import {Observable} from 'rxjs';
import {UserGateway} from '../../gateways/api-services/user-gateway';
import {ErrorModel} from '../../models/shared/error-model';

export class GetUserUseCase implements UseCase<null, UserModel | ErrorModel> {
    constructor(private userGateway: UserGateway) {}
    execute(param: null): Observable<UserModel | ErrorModel> {
        return this.userGateway.getGetUser();
    }
}
